import { FileType, SvgIcons } from '@/types/types';

const PREVIEW_FILE_TYPES: FileType[] = [
  'png',
  'jpg',
  'jpeg',
  'pdf',
  'xlsx',
  'xls',
  'pptx',
  'ppt',
  'doc',
  'docx',
];

const PREVIEW_BADGE_COLOR_BY_FILE_TYPE: Partial<Record<FileType, string>> = {
  xls: 'bg-[#47A659]',
  xlsx: 'bg-[#47A659]',
  doc: 'bg-[#1E64D6]',
  docx: 'bg-[#1E64D6]',
  ppt: 'bg-[#EA6A2A]',
  pptx: 'bg-[#EA6A2A]',
};

const PREVIEW_ICON_BY_FILE_TYPE: Partial<Record<FileType, SvgIcons>> = {
  doc: 'Word',
  docx: 'Word',
  xls: 'Excel',
  xlsx: 'Excel',
  ppt: 'PowerPoint',
  pptx: 'PowerPoint',
  jpg: 'JpegToPdf24',
  jpeg: 'JpegToPdf24',
  png: 'JpegToPdf24',
};

export const getPreviewFileType = (extension?: string): FileType => {
  const normalizedType = extension?.toLowerCase().replace(/^\./, '');

  if (
    normalizedType &&
    PREVIEW_FILE_TYPES.includes(normalizedType as FileType)
  ) {
    return normalizedType as FileType;
  }

  return 'pdf';
};

export const getPreviewBadgeColor = (fileType: FileType) =>
  PREVIEW_BADGE_COLOR_BY_FILE_TYPE[fileType] ?? 'bg-[#F43F3F]';

export const getPreviewIconName = (fileType: FileType): SvgIcons =>
  PREVIEW_ICON_BY_FILE_TYPE[fileType] ?? 'Pdf';
